import { render } from "./StockMovementsRapport.vue?vue&type=template&id=4cfcb5a8&scoped=true&ts=true"
import script from "./StockMovementsRapport.vue?vue&type=script&lang=ts"
export * from "./StockMovementsRapport.vue?vue&type=script&lang=ts"

import "./StockMovementsRapport.vue?vue&type=style&index=0&id=4cfcb5a8&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfcb5a8"]])

export default __exports__